export default __webpack_public_path__ + "static/media/asia-logo.6a1b9a80.jpeg";